// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".author-preview[data-v-658b1039]{display:flex;align-items:center;gap:8px}.author-preview__date[data-v-658b1039],.author-preview__name[data-v-658b1039]{margin:0;color:var(--text-text-low,#909398);font-family:Lato;font-size:14px;font-style:normal;font-weight:400;line-height:16px;letter-spacing:.21px}.author-preview__divider[data-v-658b1039]{width:1px;height:8px;background:#353a42}", ""]);
// Exports
module.exports = exports;
